export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  OPERATIVO_RENIECYT = 'ROLE_OPERATIVO_RENIECYT',
  ADMIN_PREMIOS = 'ROLE_ADMIN_PREMIOS',
  COORDINADOR = 'COORDINADOR',
  CONSULTA = 'CONSULTA',
  PRESIDENTE_COMISION = 'PRESIDENTE_COMISION',
  VALIDADOR_DOCUMENTAL = 'VALIDADOR_DOCUMENTAL',
  EXTERNAL_USER = 'ROLE_EXTERNAL_USER',
  EVALUADOR_INDIVIDUAL = 'EVALUADOR_INDIVIDUAL',
  EVALUADOR_PLENARIA = 'EVALUADOR_PLENARIA',
}
